<template>
  <svg aria-hidden="true" viewBox="0 0 1200 1200" ...attributes>
    <path
      fill="#63CC98"
      d="M600,440a60,60,0,1,1-60,60,60.068,60.068,0,0,1,60-60m0-40A100,100,0,1,0,700,500,100,100,0,0,0,600,400Z"
    ></path>
    <path
      fill="#1B2D3C"
      d="M810.0071,704.232a17.5414,17.5414,0,0,1-25.4734,15.6206l-.283-.1417c-24.5054-12.2524-53.3545-21.9385-85.7461-28.7886a544.3415,544.3415,0,0,0-216.9949,0c-32.3917,6.85-61.2408,16.5361-85.7461,28.7886l-.283.1417a17.5414,17.5414,0,0,1-25.4736-15.6205v-5.3843a17.6709,17.6709,0,0,1,9.842-15.8774C433.975,656.396,508.1564,640,590.0071,640s156.0321,16.396,210.158,42.97a17.6709,17.6709,0,0,1,9.842,15.8774Z"
    ></path>
    <path
      fill="#1B2D3C"
      d="M600,278.7627,300,385.9053V700c0,165.6855,134.3145,300,300,300S900,865.6855,900,700V385.9053Zm239.5845,522.429A260,260,0,0,1,340,700V414.0947l260-92.8574,260,92.8574V700A258.3351,258.3351,0,0,1,839.5845,801.1917Z"
    ></path>
  </svg>
</template>
